import { combineReducers } from 'redux';

import lang from './reducers/lang';

export default combineReducers({
  lang,
});
